import { Record, Map } from 'immutable'
import * as types from '../constants'
import { getToken, trackEvent } from '../utils'

const userRecord = Record({
  loc: new Map(),
  OAuthProvider: null,
  location: null,
  id: null,
  personalData: {},
  errors: null,
  socialAuthToken: null,
  token: getToken(),
  isLoading: !!getToken(),
  favorites: [],
  emailNotifications: false,
  isPremium: false,
  stripeLast4: null,
  stripeBrand: null,
  isUpdating: false,
  statusUpdate: getToken() ? true : false,
  isLoadingUserInfo: false,
  loginCount: null,
})

const initialState = new userRecord()

export default (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_USER_START: {
      return state.merge({ isUpdating: true })
    }
    case types.SIGNIN_SUCCESS: {
      return state.set('token', action.token)
    }
    case types.FETCH_USER_LOCATION: {
      const loc = new Map(action.loc)
      return state.set('loc', loc)
    }
    case types.FETCH_LOCAL_SIGNIN_SUCCESS: {
      return state.merge({
        token: action.payload.token,
        OAuthProvider: types.OAUTH_PROVIDERS.LOCAL,
        personalData: action.payload.user,
        id: action.payload.user.id,
        favorites: action.payload.user.propertyIds,
        emailNotifications: action.payload.user.emailNotifications,
        isPremium: action.payload.user.isPremium,
        stripeLast4: action.payload.user.stripeLast4,
        stripeBrand: action.payload.user.stripeBrand,
        loginCount: action.payload.user.loginCount,
        isLoading: false,
      })
    }
    case types.FETCH_USER_INFO_SUCCESS: {
      return state.merge({
        personalData: action.payload.user,
        id: action.payload.user.id,
        favorites: action.payload.user.propertyIds,
        emailNotifications: action.payload.user.emailNotifications,
        isPremium: action.payload.user.isPremium,
        stripeLast4: action.payload.user.stripeLast4,
        stripeBrand: action.payload.user.stripeBrand,
        loginCount: action.payload.user.loginCount,
        isLoadingUserInfo: false,
      })
    }
    case types.FETCH_SOCIAL_SIGNIN_SUCCESS: {
      return state.merge({
        socialAuthToken: action.payload.socialAuthToken,
        OAuthProvider: action.payload.OAuthProvider,
        token: action.payload.token || state.socialAuthToken, // just to check if somehow the user runs a social login meanwhile is already logged ?
        personalData: action.payload.user,
        id: action.payload.user.id,
        favorites: action.payload.user.propertyIds,
        emailNotifications: action.payload.user.emailNotifications,
        isPremium: action.payload.user.isPremium,
        stripeLast4: action.payload.user.stripeLast4,
        stripeBrand: action.payload.user.stripeBrand,
        loginCount: action.payload.user.loginCount,
        isLoading: false,
      })
    }
    case types.UPDATE_USER_SUCCESS: {
      const user = action.payload.user
      let newPersonalData = {
        firstName: user.firstName,
        lastName: user.lastName,
        locations: user.locations,
        email: user.email,
        phone: user.phone,
        zip: user.zip,
        avatarUrl: state.personalData.get('avatarUrl'),
      }
      return state.merge({
        personalData: newPersonalData,
        isUpdating: false,
      })
    }
    case types.UPDATE_USER_AVATAR_SUCCESS: {
      const avatarUrl = action.payload.avatarUrl
      let newPersonalData = {
        firstName: state.personalData.get('firstName'),
        lastName: state.personalData.get('lastName'),
        locations: state.personalData.get('locations'),
        email: state.personalData.get('email'),
        phone: state.personalData.get('phone'),
        zip: state.personalData.get('zip'),
        avatarUrl: avatarUrl && `${avatarUrl}?${Date.now()}`,
      }
      return state.merge({
        personalData: newPersonalData,
        isUpdating: false,
      })
    }
    case types.IS_LOADING_STATUS: {
      return state.merge({ isLoading: action.isLoading })
    }
    case types.IS_LOADING_USER_INFO: {
      return state.merge({ isLoadingUserInfo: action.isLoadingUserInfo })
    }
    case types.UPDATE_USER_SETTINGS_ERROR:
    case types.UPDATE_USER_ERROR: {
      return state.merge({
        errors: action.error,
        isUpdating: false,
      })
    }
    case types.FETCH_USER_INFO_ERROR: {
      return state.merge({
        isLoadingUserInfo: false,
        errors: action.error,
      })
    }
    case types.FETCH_SOCIAL_SIGNIN_ERROR:
    case types.ADD_PROPERTIES_FAVORITES__ERROR:
    case types.REMOVE_PROPERTIES_FAVORITES_ERROR:
    case types.CREATE_NEW_USER_ERROR:
    case types.FETCH_LOCAL_SIGNIN_ERROR: {
      return state.merge({
        isLoading: false,
        errors: action.error,
      })
    }
    case types.ADD_PROPERTIES_FAVORITES_SUCCESS: {
      trackEvent({ category: 'Favorite', action: 'Added to favorite property id ' + action.propertyId })
      return state.merge({
        favorites: state.favorites.push(action.propertyId),
        isLoading: false,
      })
    }
    case types.REMOVE_PROPERTIES_FAVORITES_SUCCESS: {
      trackEvent({ category: 'Favorite', action: 'Removed from favorite property id ' + action.propertyId })
      return state.merge({
        favorites: state.favorites.filter(item => item !== action.propertyId),
        isLoading: false,
      })
    }
    case types.SIGN_OUT_SUCCESS: {
      return state.merge({
        token: null,
        personalData: {},
        id: null,
        isLoading: false,
      })
    }
    case types.UPDATE_USER_STATUS: {
      return state.merge({
        statusUpdate: action.status,
      })
    }
    case types.CREATE_NEW_USER_SUCCESS: {
      return state.merge({
        token: action.payload.token,
        personalData: action.payload.user,
        emailNotifications: action.payload.user.emailNotifications,
        isPremium: action.payload.user.isPremium,
        stripeLast4: action.payload.user.stripeLast4,
        stripeBrand: action.payload.user.stripeBrand,
        loginCount: action.payload.user.loginCount,
        id: action.payload.user.id,
        favorites: action.payload.user.propertyIds,
        isLoading: false,
      })
    }
    case types.UPDATE_USER_SETTINGS_SUCCESS: {
      const user = action.payload.user
      return state.merge({
        emailNotifications: user.emailNotifications,
        isUpdating: false,
      })
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.js